import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import { DatasourceManagementState, rootReducer } from '.';

// redux-persist setup
const persistConfig = {
  key: 'datasource_management',
  storage,
  stateReconciler: autoMergeLevel2,
  blacklist: ['spatialLayers', 'mapLayerSettings'],
};
const persistedReducer = persistReducer<DatasourceManagementState>(
  persistConfig,
  rootReducer,
);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
export const persistor = persistStore(store);

export type DatasourceDispatch = typeof store.dispatch;
